import { render, staticRenderFns } from "./about-new.vue?vue&type=template&id=42193c0b&scoped=true&"
import script from "./about-new.vue?vue&type=script&lang=js&"
export * from "./about-new.vue?vue&type=script&lang=js&"
import style0 from "./about-new.vue?vue&type=style&index=0&id=42193c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42193c0b",
  null
  
)

export default component.exports